import { render, staticRenderFns } from "./userDialog.vue?vue&type=template&id=485bf0c5&"
import script from "./userDialog.vue?vue&type=script&lang=js&"
export * from "./userDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports